import claimFormReducer from './claimFormReducer';
import orderPaymentReducer from './orderPaymentReducer';
import orderReducer from './orderReducer';
import labOrderReducer from './labOrderReducer';
import trialOrderReducer from './trialOrderReducer';
import revenueOrderReducer from './revenueOrderReducer';
import orderPromotionReducer from './orderPromotionReducer';
import orderWarrantyReducer from './orderWarrantyReducer';

const orderReducers ={
  claimForm: claimFormReducer,
  orderPayment: orderPaymentReducer,
  labOrder: labOrderReducer,
  trialOrder: trialOrderReducer,
  revenueOrder: revenueOrderReducer,
  order: orderReducer,
  orderPromotion: orderPromotionReducer,
  orderWarranty: orderWarrantyReducer,
};

export default orderReducers;